import React, { useCallback } from 'react';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import { usePersonalizationPromoInformation } from 'reactApp/hooks/usePersonalizationPromoInformation';
import { usePersonalizationModalImageUrl } from 'reactApp/ui/PersonalizationModal/PersonalizationModal.helpers';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './PersonalizationModal.css';

interface PersonalizationModalProps {
    onClose: () => void;
}

export const PersonalizationModal: React.FC<PersonalizationModalProps> = ({ onClose }) => {
    const { currentSpace, promoSpace, handleBuy, showPromo } = usePersonalizationPromoInformation();

    const currentSpaceText: string = currentSpace ? `${currentSpace.space} ${currentSpace.units}` : '';
    const promoSpaceText: string = promoSpace ? `${promoSpace.space} ${promoSpace.units}` : '';
    const imageUrl: string | undefined = usePersonalizationModalImageUrl(promoSpace?.space);

    const handleShow = useCallback(() => {
        sendDwh({
            eventCategory: 'personalization-modal',
            action: 'show',
        });
    }, []);

    const handleClick = useCallback(() => {
        sendDwh({
            eventCategory: 'personalization-modal',
            action: 'click',
            dwhData: {
                name: 'mnz_personalization_modal',
            },
        });
        handleBuy();
    }, [handleBuy]);

    if (!showPromo) {
        return null;
    }

    return (
        <WhatsNewDialog
            className={styles.root}
            title="С тарифом побольше поместятся все фото"
            /* eslint-disable-next-line no-irregular-whitespace */
            text={`Сейчас у вас ${currentSpaceText} с Mail Space, к ним добавится ${promoSpaceText} — хватит для фото из путешествий, видео с праздников и важных документов`}
            primaryButtonText="Попробовать за 1 ₽"
            imageUrl={imageUrl}
            imageWrapperClassName={styles.imageWrapper}
            imageClassName={styles.image}
            textClassName={styles.text}
            closeIconWrapperClassName={styles.closeButton}
            closeIconClassName={styles.closeIcon}
            closeAfterClick
            closeOnDimmerClick
            closable
            onClose={onClose}
            contentClassName={styles.content}
            onClick={handleClick}
            onShow={handleShow}
        />
    );
};
